import { DescontoService } from './../../services/desconto/desconto.service';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogRemoveComponent } from './dialog-remove/dialog-remove.component';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';

@Component({
  selector: 'bs-remove',
  templateUrl: './remove.component.html',
  styleUrls: ['./remove.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RemoveComponent,
      multi: true,
    },
  ],
})
export class RemoveComponent {
  @Input() content?: {
    h1: string;
    p: string;
    button: string;
  };
  value: any;
  ngControl!: NgControl | null;
  onChange?: (value: boolean) => void;
  onTouched?: () => void;
  constructor(
      public dialog: MatDialog,
      private readonly descontoService: DescontoService,
      private readonly toast: UtilsBsHotToastService,
    ) {}

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  openDialog() {
    if(this.descontoService.descontoRodapeValue$.value.value != 0){
      this.toast.showWarning('Só é possível excluir um item quando não há desconto de rodapé inserido.')
      return;
    }
    this.dialog
      .open(DialogRemoveComponent, {
        width: '480px',
        maxWidth: 'calc(100vw - 32px)',
        autoFocus: false,
        data: {
          content: this.content,
        },
      })
      .afterClosed()
      .subscribe((remove) => {
        this.onChange?.apply(this, [remove]);
        this.writeValue(remove);
      });
  }
}
